import { request } from "./request";

export default {
  async fetchAll() {
    return await request("/api/partners");
  },

  async fetch(id) {
    return await request(`/api/partners/${encodeURIComponent(id)}`);
  },
};
